import { Tooltip } from 'shared/ui/Tooltip';
import { PendingIcon } from 'entities/campaign';
import { useContractorDateWithTimeZone } from 'shared/lib/timezones';

import { BLOCKING_BUDGET_INPUT_MESSAGE } from '../constants';

interface PendingChangesIconProps {
  appliesAt: string | null;
  blockingMessage?: string;
  className?: string;
}

export function PendingChangesIcon({ appliesAt, blockingMessage, className }: PendingChangesIconProps) {
  const getPendingDate = useContractorDateWithTimeZone();
  const formattedAppliesAt = appliesAt && getPendingDate(appliesAt);
  const tooltipContent = `${blockingMessage ?? BLOCKING_BUDGET_INPUT_MESSAGE} ${formattedAppliesAt}`;

  return (
    <Tooltip
      placement="bottom-end"
      content={tooltipContent}
    >
      <PendingIcon className={className} />
    </Tooltip>
  );
}
